/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from "react"
import { Label } from "reactstrap";
import Select from 'react-select';
import moment from 'moment';
import RandomNumberAnimation from '../../../helpers/animatonNumber';
import { useDispatch, useSelector } from "react-redux";

import { getRegistrySetRequestCount } from "../../../store/RegistrySetRequest/actions"


const PreviousRequestCount = () => {
    const dispatch = useDispatch();

    const { CountBranding } = useSelector((state: any) => state.RegistrySetRequest)

    const [finalNumber, setFinalNumber] = useState(undefined);
    const [monthsArray, setMonthsArray] = useState<any>([]);
    const [selectedMonth, setSelectedMonth] = useState<any>(undefined);

    useEffect(() => {
        if (selectedMonth) {
            const from = moment().month(Number(selectedMonth.value) - 1).startOf('month').format('YYYY-MM-DD');
            const to = moment().month(Number(selectedMonth.value) - 1).endOf('month').format('YYYY-MM-DD');
            dispatch(getRegistrySetRequestCount({ filters:{ from, to } }))
        }
    }, [selectedMonth])
    useEffect(() => {
        setFinalNumber(CountBranding)
    }, [CountBranding])

    useEffect(() => {
        arrayActualMonths()
    }, [])

    const arrayActualMonths = () => {
        const currentMonth = moment().month();
        const newArray = [];
        for (let i = 0; i <= currentMonth; i++) {
            const monthLabel = moment().month(i).format('MMMM');
            const monthValue = moment().month(i).format('M');
            newArray.push({
                value: monthValue,
                label: monthLabel
            });
        }
        setMonthsArray(newArray)
    }
    return (
        <div className=" ms-5 ps-5 row justify-content-center align-items-center" >
            <Label className='justify-content-center align-items-center d-flex' >
                <div className='text-center mb-1' > Previous Months Requests Count </div>
            </Label>
            < div className='col-12 mb-2 h-25' >
                <Select
                    styles={{ menuList: (provided: any) => ({ ...provided, maxHeight: '150px' }) }}
                    onChange={(selectedOption: any) => setSelectedMonth(selectedOption)}
                    value={selectedMonth}
                    options={monthsArray}
                    classNamePrefix="select2-selection"
                />
            </div>
            < h2 className='text-center mb-1' >
                <div className='number-display'
                    style={{ display: finalNumber === undefined ? "none" : "block" }}
                >
                    {RandomNumberAnimation({ finalNumber: finalNumber })}
                </div>
            </h2>
        </div>
    )
}


export default PreviousRequestCount